import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FiledViewItem from "./FiledViewItem";
import FiledSummaryDetails from "./FiledSummaryDetails";

export default function FiledDoneDialog({ open, onClose, item }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <CheckCircleIcon color="success" />
        Documento radicado con éxito
      </DialogTitle>
      <DialogContent>
        {item && (
          <>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <FiledViewItem item={item} />
            </Box>
            <FiledSummaryDetails item={item} />
          </>
        )}
        <DialogContentText sx={{ mt: 1 }}>
          Puedes acceder a este radicado nuevamente en la pestaña Radicados.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" autoFocus>
          Ir a Radicados
        </Button>
      </DialogActions>
    </Dialog>
  );
}
